import { render, staticRenderFns } from "./streetStatistics.vue?vue&type=template&id=f66485c4&scoped=true&"
import script from "./streetStatistics.vue?vue&type=script&lang=js&"
export * from "./streetStatistics.vue?vue&type=script&lang=js&"
import style0 from "./streetStatistics.vue?vue&type=style&index=0&id=f66485c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66485c4",
  null
  
)

export default component.exports